const checklisttemplatecategory = {
	module: "Utstyrsjekkliste",
	list_title: "Utstyrsjekklister",
	new_title: "Ny utstyrsjekkliste",
	edit_title: "Endre utstyrsjekkliste",
	type: "Sjekklistetype",
	category: "Kategori",
	name: "Navn",
};
export default checklisttemplatecategory;